import CheckoutResume from "./CheckoutResume";

export default CheckoutResume;
